import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-impressum',
  imports: [RouterLink],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpressumComponent implements OnInit {
  private readonly seo = inject(SeoService);
  private readonly siteConfig = inject(SiteConfigService);

  readonly impressum = this.siteConfig.impressum;

  ngOnInit(): void {
    this.seo.apply({
      title: 'Impresszum – ALL-IN-DEV',
      description: 'Az ALL-IN-DEV impresszuma.',
      ogTitle: 'Impresszum – ALL-IN-DEV',
      ogDescription: 'Az ALL-IN-DEV impresszuma.',
    });
  }
}
